<template>
    <div class="site-search">
        <div class="search-group">
            <input 
                type="text" 
                v-model="text" 
                placeholder="Site" 
                @focus="showResults = true"
                @keyup.prevent="searchKeyup" 
                class="site-search-input form-control"
            >
            <i 
                class="fa fa-times search-clear" 
                @click="clear(true)"
            />
        </div>
        <div 
            class="results-container" 
            v-if="results.length && showResults"
        >
            <ul class="results">
                <li 
                    v-for="(s, index) of results" 
                    :key="s.id"
                >
                    <a 
                        href="#" 
                        @click.prevent="makeSelection(index)" 
                        :class="{focussed : index === selectedIndex}"
                    >{{ getSiteText(s) }}</a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import SiteService from "../services/SitesService";

export default {
    name: "SiteSearch",
    props: {
        site: {
            type: Object,
            default: () => {
                return {
                    name: '',
                }
            }
        },
        siteId: {
            type: [Number, String],
            default: () => null,
        },
        showCustomer: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            text: "",
            results: [],
            showResults: false,
            selectedIndex: null
        };
    },

    watch: {
        site (val) {
            this.text = this.getSiteText(val)
        },
        siteId:{
            immediate: true,
            handler () {
                this.loadFromID();
            }
        }
    },

    mounted () {
        if (this.site !== null) {
            this.text = this.getSiteText(this.site);
        }

        this.loadFromID();
    },

    methods: {
        searchKeyup () {
            this.showResults = false;
            if (this.text.length === 0) {
                this.clear();
            }
            if (this.text.length > 2) {
                setTimeout(this.search, 250);
            }
        },

        clear (emit = false) {
            if (emit) {
                this.$emit("change", null);
            }
            this.text = "";
            this.selectedIndex = null;
            this.showResults = false;
            this.results = [];
        },

        makeSelection (index) {
            this.$emit("change", this.results[index]);
            this.text = this.getSiteText(this.results[index]);
            this.showResults = false;
        },

        search () {
            SiteService.search({
                "filter[keyword]": this.text,
                include: ["customer", "customer.sites"]
            }).then(
                res => {
                    this.results = res.data.data;
                    this.showResults = true;
                },
                () => {
                    alert("Error: Failed to load sites");
                }
            );
        },
            
        loadFromID () {
            if (this.siteId === null) {
                return;
            }

            SiteService.get(this.siteId).then(res => {
                this.results = [res.data];
                this.makeSelection(0);
            });
        },

        getSiteText(site) {
            if (!site || !site.name) {
                return '';
            }

            let text = '#' + site.site_no + ' ' 

            if (this.showCustomer) {
                text += site.customer.company_name + ': '
            }
            
            text += site.name;

            return text;
        },

        setResults (results) {
            this.results = results;
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/SiteSearchComponent.vue